// extracted by mini-css-extract-plugin
export default {"registration":"profileandregform-module_registration_pBmub","input-sub":"profileandregform-module_input-sub_X_d7H"};